module.exports = __webpack_public_path__ + "static/media/IMG_20180319_022621.61429e68.webp";